import { render } from "./AdvisoryForm.vue?vue&type=template&id=673fae0a"
import script from "./AdvisoryForm.vue?vue&type=script&lang=js"
export * from "./AdvisoryForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__